import ru from './ru/ru.js'
import en from './en/en.js'
import fr from './fr/fr.js'

export const locales = {
  ru,
  en,
  fr,
}
